<template>
  <info-screen
    :title="t('grace-period-expired.title')"
    :message="t('grace-period-expired.message')"
    :image="CardErrorImage"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import CardErrorImage from '@/assets/card-error.svg'
import InfoScreen from '@/components/InfoScreen.vue'
import { useAuthStore } from '@/store/auth'

const authStore = useAuthStore()
const { refreshBillingStatus } = authStore
const { gracePeriodExpired } = storeToRefs(authStore)
const router = useRouter()
const { t } = useI18n()

onMounted(() => {
  refreshBillingStatus()
  if (!gracePeriodExpired) {
    router.push({
      name: 'employees'
    })
  }
})

watch(gracePeriodExpired, () => {
  if (!gracePeriodExpired) {
    router.push({
      name: 'employees'
    })
  }
})
</script>
